<div class="audience-geo">
  <app-form-with-ranges
    [title]="'Страна'"
    [params]="prepareFormParamsForGeoTab()"
    [isEditEnabled]="isEditEnabled()"
    (formRangeChanged)="handleGeoFormRangeChange($event)"
  />
</div>
